import ApiClient from './apiClient'
import {
  DashboardContentRequest,
  DashboardWeeklyContentRequest,
  DataExists,
  CardResponse,
  RankingResponse,
  DailyEngagementResponse,
  DailyLoadFactorGraphResponse,
  DailyPerformanceResponse,
  DailyConcentrationResponse,
  WeeklyGraphResponse,
  DashboardRangeContentRequest,
} from '../types/dashboard'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyDataExists = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/renderer/dashboard/daily/exists',
  (result: DataExists) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyDataExists = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/renderer/dashboard/weekly/exists',
  (result: DataExists) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeDataExists = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/renderer/dashboard/range/exists',
  (result: DataExists) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyEngagementCard = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/engagement/daily/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyEngagementCard = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/engagement/weekly/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeEngagementCard = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/engagement/range/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyPerformanceCard = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/performance/daily/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyPerformanceCard = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/performance/weekly/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangePerformanceCard = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/performance/range/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyConcentrationCard = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/concentration/daily/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyConcentrationCard = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/concentration/weekly/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeConcentrationCard = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/concentration/range/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyLoadFactorCard = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/load_factor/daily/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyLoadFactorCard = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/load_factor/weekly/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeLoadFactorCard = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/load_factor/range/card',
  (result: CardResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyEngagementRanking = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/engagement/daily/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyEngagementRanking = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/engagement/weekly/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeEngagementRanking = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/engagement/range/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyPerformanceRanking = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/performance/daily/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyPerformanceRanking = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/performance/weekly/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangePerformanceRanking = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/performance/range/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyConcentrationRanking = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/concentration/daily/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyConcentrationRanking = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/concentration/weekly/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeConcentrationRanking = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/concentration/range/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyLoadFactorRanking = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/load_factor/daily/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyLoadFactorRanking = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/load_factor/weekly/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeLoadFactorRanking = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/load_factor/range/ranking',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyTotalRanking = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/renderer/dashboard/daily/ranking_total',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyTotalRanking = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/renderer/dashboard/weekly/ranking_total',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeTotalRanking = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/renderer/dashboard/range/ranking_total',
  (result: RankingResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyEngagementGraph = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/engagement/daily/graph',
  (result: DailyEngagementResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyEngagementGraph = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/engagement/weekly/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeEngagementGraph = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/engagement/range/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyPerformanceGraph = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/performance/daily/graph',
  (result: DailyPerformanceResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyPerformanceGraph = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/performance/weekly/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangePerformanceGraph = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/performance/range/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyConcentrationGraph = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/concentration/daily/graph',
  (result: DailyConcentrationResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyConcentrationGraph = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/concentration/weekly/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeConcentrationGraph = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/concentration/range/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDailyLoadFactorGraph = async (params: DashboardContentRequest): Promise<any> => ApiClient.get(
  '/api/v3/features/load_factor/daily/graph',
  (result: DailyLoadFactorGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyLoadFactorGraph = async (params: DashboardWeeklyContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/load_factor/weekly/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRangeLoadFactorGraph = async (params: DashboardRangeContentRequest): Promise<any> => ApiClient.get(
  '/api/v1/features/load_factor/range/graph',
  (result: WeeklyGraphResponse) => result,
  params,
)
